import script from "./VensoInvoiceRequestOrder.vue?vue&type=script&setup=true&lang=ts"
export * from "./VensoInvoiceRequestOrder.vue?vue&type=script&setup=true&lang=ts"

import "./VensoInvoiceRequestOrder.vue?vue&type=style&index=0&id=01bca742&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01bca742"]])

export default __exports__